import React from 'react'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import SimpleTextField from '../../../../components/Forms/SimpleTextField'
import EPCRCard from '../../../../components/Cards/EPCRCard'

const Transport = ({ formValues, handleChange }) => {
  return (
    <EPCRCard>
      <Typography variant="title3">Transport</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6}>
          <FormControl fullWidth>
            <InputLabel>Transport Type</InputLabel>
            <Select
              value={formValues?.plan?.transportType ?? ''}
              onChange={(e) =>
                handleChange({
                  moduleName: 'plan',
                  field: 'transportType',
                  value: e.target.value,
                })
              }
              label="Transport Type"
            >
              <MenuItem value="Ambulance Stretcher">
                Ambulance Stretcher
              </MenuItem>
              <MenuItem value="Wheelchair">Wheelchair</MenuItem>
              <MenuItem value="Car Seat">Car Seat</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Autocomplete
            value={formValues?.plan?.transportSafetyFeatures ?? []}
            onChange={(e, value) =>
              handleChange({
                moduleName: 'plan',
                field: 'transportSafetyFeatures',
                value,
              })
            }
            multiple
            options={[
              'Seatbelt',
              '5-Point Harness',
              'Paediatric Harness',
              'Car Seat',
            ]}
            renderInput={(params) => (
              <TextField {...params} label="Safety Features Used" />
            )}
          />
        </Grid>
      </Grid>
    </EPCRCard>
  )
}

export default Transport
